import { render, staticRenderFns } from "./introPop.vue?vue&type=template&id=0bef2c7e&scoped=true&"
import script from "./introPop.vue?vue&type=script&lang=js&"
export * from "./introPop.vue?vue&type=script&lang=js&"
import style0 from "./introPop.vue?vue&type=style&index=0&id=0bef2c7e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bef2c7e",
  null
  
)

export default component.exports